import { createAsyncThunk } from "@reduxjs/toolkit";
import { ax } from "src/common/api/apiClient";
import { IApi } from "src/common/typings/app";
import { IAddRFIDTag, IAddSecondaryInspection, IAddWebocInfo } from "src/common/typings/customs";

export const createWebocInfo = createAsyncThunk(
  "customs/createWebocInfo",
  async (formRecord: IAddWebocInfo) => {
    try {
      const res = await ax.post<IApi>("/create-webocinfo", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const updateWebocInfo = createAsyncThunk(
  "customs/updateWebocInfo",
  async (formRecord: IAddWebocInfo) => {
    try {
      const res = await ax.put<IApi>("/update-webocinfo", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const createRFIDTag = createAsyncThunk(
  "customs/createRFIDTag",
  async (formRecord: IAddRFIDTag) => {
    try {
      const res = await ax.post<IApi>("/create-rfid-tag", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const updateRFIDTag = createAsyncThunk(
  "customs/updateRFIDTag",
  async (formRecord: IAddRFIDTag) => {
    try {
      const res = await ax.put<IApi>("/update-rfid-tag", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const deleteRFIDTag = createAsyncThunk(
  "vehicle/delete-inspection-scanner",
  async (id: string): Promise<any> => {
    try {
      const res = await ax.delete<IApi>(`/delete-rfid-tag/${id}`);
      if (res.data.isSuccess === true) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getAllSecondaryInspection = createAsyncThunk(
  "customs/getAllSecondaryInspection",
  async (formRecord: any) => {
    try {
      const res = await ax.post<IApi>("/gate-pass-scan-secondary-get-all", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getSecondaryInspectionVehicles = createAsyncThunk(
  "customs/getSecondaryInspectionVehicles",
  async (queryString: any) => {
    try {
      const res = await ax.get<IApi>(
        `/gate-pass-scan-secondary-search?VehicleNumber=${queryString}`
      );
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const updateSecondaryInspection = createAsyncThunk(
  "customs/updateSecondaryInspection",
  async (formRecord: IAddSecondaryInspection) => {
    try {
      const res = await ax.post<IApi>("/update-gate-pass-scan-secondary", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
